<template>
  <div class="d-flex flex-row w-100 h-100">
    <div class="task-section d-flex flex-column px-4">
      <div class="d-flex flex-column">
        <div
          class="py-5 d-flex justify-space-between flex-wrap align-center"
          style="gap: 15px">
          <v-sheet>
            <span class="taskTypeTitle" v-if="currentTaskType">{{ currentTaskType.name }}</span>
          </v-sheet>
          <v-sheet
            :class="{
              'flex-grow-1': is3dOpened,
              'order-3': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md,
            }"
            :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '100%' : 250">
            <v-text-field
              class="customSearchBox"
              outlined
              rounded
              dense
              hide-details
              v-model="options.search"
              :loading="loading || linkUpdating"
              placeholder="Search..."
              append-icon="mdi-magnify"></v-text-field>
          </v-sheet>
          <v-sheet>
            <v-btn
              class="me-2 border-rounded rounded-md"
              :class="{ 'order-2': $vuetify.breakpoint.sm }"
              outlined
              @click="addProject()"
              color="primary"
             :disabled="!$has(permissions.TaskBoardProjects.Create)"
              v-if="$route.name !== 'schedule'"
              ><v-icon left>mdi-plus</v-icon> Add Project</v-btn
            >
            <v-btn
              @click="openTask()"
              color="primary"
              v-has="permissions.Tasks.Create"
              v-if="$route.name !== 'schedule'"
              ><v-icon left>mdi-plus</v-icon> Add Task</v-btn
            >
            <v-btn @click="openEvent()" color="primary" v-if="$route.name === 'schedule'"
              ><v-icon left>mdi-plus</v-icon> Add Event</v-btn
            >
          </v-sheet>
        </div>
        <v-divider style="width: 99%"></v-divider>
        <div
          class="d-flex align-center py-3 pe-4"
          :class="{
            'flex-column justify-center': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
            'justify-content-between': !$vuetify.breakpoint.xs || !$vuetify.breakpoint.sm,
          }">
          <v-tabs
            hide-slider
            class="task-tabs"
            :style="{ width: $vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 'auto' : '100%' }">
            <v-tab
              exact
              exact-active-class="activeTab"
              :disabled="!$has(tab.permissions)"
              v-for="tab in tabs"
              :to="tab.path"
              :key="tab.name + 1"
              @change="onTabChange(tab)"
            >
              <v-icon small left>{{ tab.icon }}</v-icon>
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <div
            class="actions d-flex"
            :class="{ 'pt-3': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }">
            <!-- {{ selectedTasks }} ---------- {{ collectionSelected }} -->
            <v-tooltip top v-if="$route.name === 'gantt' && collectionSelected" >
              <template v-slot:activator="{ on, attrs }">
                <span   v-bind="attrs"
                v-on="on">
                  <v-btn
                  :disabled="!$has(permissions.Tasks.Update)"
                  color="primary"
                  outlined
                  fab
                  small
                  class="mr-2 mb-0 toolbar-item"

                  @click="editSelectedGanttTasks">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                </span>

              </template>
              {{ $has(permissions.Tasks.Update)?'Edit Selected Tasks':'Permission Required' }}
            </v-tooltip>
            <v-tooltip top v-if="$route.name === 'gantt' && collectionSelected">
              <template v-slot:activator="{ on, attrs }">
                <span  v-bind="attrs"
                v-on="on">
                <v-btn
                 :disabled="!$has(permissions.Tasks.Delete)"
                  color="error"
                  outlined
                  fab
                  small
                  class="mr-2 mb-0 toolbar-item"

                  @click="deleteSelectedGanttTasks">
                  <v-icon small>fas fa-trash</v-icon>
                </v-btn>
                </span>

              </template>
            {{ $has(permissions.Tasks.Delete)?'Delete':'Permission Required' }}
            </v-tooltip>

            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  color="primary"
                  class="mr-2"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  :outlined="!ganttToolbar.includes('resourcePanel')"
                  @click="ganttActionsClick('resourcePanel')">
                  <v-icon> mdi-layers-triple</v-icon>
                </v-btn>
              </template>

              Resource Panel
            </v-tooltip>
            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  color="primary"
                  class="mr-2"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  :outlined="!ganttToolbar.includes('highlightCriticalPath')"
                  @click="ganttActionsClick('highlightCriticalPath')">
                  <v-icon>mdi-transit-connection-variant </v-icon>
                </v-btn>
              </template>

              Critical Path
            </v-tooltip>

            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  :outlined="!ganttToolbar.includes('autoSchedule')"
                  fab
                  color="primary"
                  value="autoSchedule"
                  elevation="0"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="ganttActionsClick('autoSchedule')">
                  <v-icon x-small>fa-solid fa-calendar-week</v-icon>
                </v-btn>
              </template>
              Auto Schedule
            </v-tooltip>
            <v-tooltip top v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  fab
                  color="primary"
                  class="mr-2 mb-0 toolbar-item"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  @click="zoomAction">
                  <v-icon>mdi-fit-to-screen-outline</v-icon>
                </v-btn>
              </template>
              Zoom To Fit
            </v-tooltip>

            <v-menu offset-y bottom v-if="$route.name === 'gantt'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="primary"
                  v-bind="attrs"
                  class="me-2 mb-0"
                  v-on="on"
                  style="margin-bottom: 10px">
                  Scale <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item-group v-model="selectedScaleOption">
                  <v-list-item v-for="item in scaleOptions" :key="item.value" :value="item.value">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
            <v-btn
              v-if="$route.name === 'kanban' || $route.name === 'list'"
              color="primary"
              outlined
              @click="showAllTasksIn3d"
              class="mx-2">
              <v-icon left>mdi-cube-outline</v-icon> Isolate All
            </v-btn>
            <v-badge
              :value="activeFilterCount > 0"
              :content="activeFilterCount"
              color="error"
              overlap
              offset-x="10"
              offset-y="10">
              <v-btn color="primary" outlined @click="openFilters">
                <v-icon left>{{ activeFilterCount > 0 ? 'mdi-filter-check' : 'mdi-filter' }}</v-icon> Filters
              </v-btn>
            </v-badge>
          </div>
        </div>
      </div>
      <keep-alive>
        <router-view
          class="flex-grow-1"
          :include="['app-gantt', 'app-kanban', 'app-scheduler','app-task-board-charts']"
          v-show="!loadType"
          ref="dhtmlx"
          :ganttToolbar="ganttToolbar"
          :selectedScaleOption="selectedScaleOption"
          @collectionSelected="updateCollectionSelected"
          :currentTaskType="currentTaskType"
          @updateViewerStatusColors="updateViewerStatusColors"
          @showIn3d="showTasksOn3d"
          @edit-completed="handleEditComplete($event)"></router-view>
      </keep-alive>

      <EditTask ref="editTask"></EditTask>
      <EditProject ref="editProject"></EditProject>
      <TaskFilters ref="taskFilters"></TaskFilters>
      <RecurringEvent ref="recurringEvent"></RecurringEvent>
    </div>
    <v-sheet
      v-show="viewerOpened"
      class="task-viewers-section-wrapper"
      style="width: 30vw; min-width: 400px; flex-shrink: 0;">
      <ViewersSection
        ref="viewersSection"
        feature="task"
        :enabledTabs="['3D View', '2D View', '360 View']"
        :viewerTab.sync="viewerTab"
        :usePhotoSphereViewer="false"
        @closeViewersSection="onCloseViewer"
        @tab-changed="onTabChanged"
        @expand="onExpandViewer">
        <template #viewer-overlay="{ activeTab }">
          <ViewerTaskColoring
            v-if="activeTab === '3D View'"
            ref="viewerTaskColoring"
            :isolation-info-by-task-id="taskIsolationInfoByTaskId"
            :isolated-tags="isolatedTagsForViewer" />
        </template>
        <template #header-controls="{ activeTab }">
          <!--
            Phase 3 — Compact icon-button + corner badge pattern (per design feedback).
            Visible on kanban route + 3D tab when tasks are isolated. Matches the visual
            weight of the surrounding expand/close buttons (icon-only chrome) and uses
            the universal notification-badge pattern for the count. The icon
            (mdi-vector-selection) reads as "items currently isolated in the viewer."
            Clicking opens IsolatedTagsDialog with the isolated tags.
          -->
          <button
            v-if="activeTab === '3D View' && $route.name === 'kanban' && isolatedTasks.length > 0"
            type="button"
            class="task-header-isolated-btn"
            :aria-label="`${isolatedTasks.length} ${isolatedTasks.length === 1 ? 'task' : 'tasks'} isolated — click to view list`"
            :title="`${isolatedTasks.length} ${isolatedTasks.length === 1 ? 'task' : 'tasks'} isolated`"
            @click="taskIsolatedDialogOpen = true">
            <v-icon size="18" class="task-header-isolated-btn__icon">mdi-vector-selection</v-icon>
            <span class="task-header-isolated-btn__badge" aria-hidden="true">
              {{ isolatedTasks.length > 99 ? '99+' : isolatedTasks.length }}
            </span>
          </button>
        </template>
      </ViewersSection>
      <IsolatedTagsDialog
        v-model="taskIsolatedDialogOpen"
        :items="isolatedTagsForViewer"
        title="Isolated Tags"
        footer-text="Tags currently isolated in the 3D viewer"
        @close="taskIsolatedDialogOpen = false" />
    </v-sheet>
  </div>
</template>

<script>
  // import UserAvatar from '@Share/components/UserAvatar.vue';
  // import generalSelector from '@Share/components/generalSelector.vue';
  import EditTask from '../components/EditTask.vue';
  // Phase 3 of TaskBoard viewer migration: switched from feature-owned wrapper
  // (TaskViewerSection) to the shared multi-modal Dashboard/ViewersSection.
  // The slot-rendered ViewerTaskColoring stays mounted only on the 3D tab; the
  // tab-changed event drives 2D-plan and 360-panorama transitions.
  import ViewersSection from '@Dashboard/components/ViewersSection.vue';
  import ViewerTaskColoring from '../components/ViewerTaskColoring.vue';
  import IsolatedTagsDialog from '@Share/components/IsolatedTagsDialog.vue';
  import { ForgeAvaInspect, ForgeScaffold, Image360 } from '@/scripts/js/forgeModels';
  import { getBoxAroundPoints } from '@/utils/threejsUtils';
  import { log, error as debugError } from '@/utils/debugLogger';
  import EditProject from '@Contract/components/EditProject.vue';
  import TaskFilters from '../components/TaskFilters.vue';
  import { mapGetters } from 'vuex';
  import permissions from '@Share/config/permissions';
  import { TaskFieldType } from '@Share/config/enums';
  import RecurringEvent from '@/features/Task/components/RecurringEvent.vue';
  import { $has } from '@/utils';
  import images360Service from '@Dashboard/service/images360.service';
  import { resolveTaskSpatialIntent } from '@/features/Tags/utils/tagSpatialNavigation';
  import {
    prefetchTasksIsolation,
    getTaskIsolationInfo,
    getTaskEffectiveTagIds,
  } from '@Task/utils/taskIsolation';

  export default {
    name: 'main-task',
    data() {
      return {
        // Initial base filters. getTaskType() rebuilds this on every board load
        // (base filters with current-board URLs + the board's custom fields), so
        // these URLs are placeholders only — kept non-empty because
        // preloadFilterOptions() is guarded by `filters.length > 0`.
        filters: [
          {
            label: 'Contract',
            placeholder: 'Contract',
            prop: 'contractId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/contractId`,
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Project',
            placeholder: 'Project',
            prop: 'projectId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/projectId`,
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Status',
            placeholder: 'Status',
            prop: 'statusId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/statusId`,
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Participants',
            placeholder: 'Participants',
            prop: 'participantId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/participantId`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Approved By',
            placeholder: 'Approved By',
            prop: 'approvedById',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/approvedById`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Reported By',
            placeholder: 'Reported By',
            prop: 'reportedById',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/reportedById`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Project Manager',
            placeholder: 'Project Manager',
            prop: 'projectManager',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/projectManager`,
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'WBS element ID',
            placeholder: 'WBS element ID',
            prop: 'wbsElementId',
            url: `/api/Tasks/Filters/${this.$route.params.taskTypeId}/wbsElementId`,
            itemText: 'name',
            itemValue: 'id',
          },
        ],
        loadType: false,
        selectedFilter: [0],
        timerId: null,
        permissions,
        is3dOpened: false,
        TaskFieldType,
        // Base filter metadata. NOTE: the option-source `url` is intentionally
        // NOT defined here — it is built per-board in getTaskType() against the
        // CURRENT taskTypeId. data() runs only once (index.vue is the persistent
        // parent route component, reused across taskTypeId changes), so embedding
        // the taskTypeId here would freeze it to the first board opened and make
        // Status/Contract/etc. always load the first board's options. The url
        // segment equals each filter's `prop`.
        tempFilters: [
          {
            label: 'Contract',
            placeholder: 'Contract',
            prop: 'contractId',
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Project',
            placeholder: 'Project',
            prop: 'projectId',
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Status',
            placeholder: 'Status',
            prop: 'statusId',
            itemText: 'name',
            itemValue: 'id',
          },
          {
            label: 'Participants',
            placeholder: 'Participants',
            prop: 'participantId',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Approved By',
            placeholder: 'Approved By',
            prop: 'approvedById',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Reported By',
            placeholder: 'Reported By',
            prop: 'reportedById',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'Project Manager',
            placeholder: 'Project Manager',
            prop: 'projectManager',
            itemText: 'firstName',
            itemValue: 'id',
            type: 'userList',
          },
          {
            label: 'WBS element ID',
            placeholder: 'WBS element ID',
            prop: 'wbsElementId',
            itemText: 'name',
            itemValue: 'id',
          },
        ],
        ganttToolbar: [],
        collectionSelected: false,
        selectedScaleOption: 'day',
        scaleOptions: [
          { name: 'Day', value: 'day' },
          { name: 'Week', value: 'week' },
          { name: 'Yearly Quarter', value: 'quarter' },
          { name: 'Year', value: 'year' },
        ],
        // Phase 3 of TaskBoard viewer migration — local state replacing the
        // imperative open/close pattern of the old TaskViewerSection wrapper.
        // Mirrors the Registers/views/index.vue convention.
        viewerOpened: false,
        viewerTab: '3D View',
        // Tags associated with the currently-isolated tasks. Populated by
        // showTasksOn3d and used by isolateTasksIn{3d,2d,360}Viewer to drive
        // cross-viewer transitions.
        isolatedTagsForViewer: [],
        // Normalized server plans for the currently isolated tasks. Kept
        // separate from task.forgeTagsIds so monitoring D3 remains intact.
        taskIsolationInfoByTaskId: {},
        // Phase 3 — preserves the "X Tasks Isolated" button + dialog from the
        // old TaskViewerSection wrapper. The button shows on the kanban route
        // (matching the old visibility rule) and renders into the shared
        // ViewersSection's viewer-sidebar slot.
        taskIsolatedDialogOpen: false,
      };
    },
    computed: {
      ...mapGetters('TASK', { loading: 'GET_LOADING', entries: 'GET_TASKS' }),
      ...mapGetters('LINK', { linkUpdating: 'GET_UPDATE_LOADING' }),
      currentTaskType: {
        get() {
          return this.$store.getters['TASK_MANAGER/GET_CURRENT_TASK_TYPE'];
        },
        set(value) {
          this.$store.commit('TASK_MANAGER/SET_CURRENT_TASK_TYPE', value);
        },
      },
      activeFilters() {
        return this.selectedFilter.map((index) => this.filters[index]);
      },
      options: {
        get() {
          return this.$store.getters['TASK/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('TASK/SET_OPTIONS', val);
        },
      },
      isolatedTasks: {
        get() {
          return this.$store.getters['TASK/GET_ISOLATED_TASKS'];
        },
        set(value) {
          this.$store.commit('TASK/SET_ISOLATED_TASKS', value);
        },
      },
      tabs() {
        return [
          // {
          //   name: 'Tasks',
          //   icon: 'mdi-file-tree',
          //   path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}`,
          // },
          {
            name: 'Board',
            icon: 'mdi-billboard',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/`,
            permissions: [permissions.TaskTracker.View],
          },
          {
            name: 'List',
            icon: 'mdi-table',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/list`,
            permissions: [permissions.TaskTracker.View],
          },
          {
            name: 'Gantt',
            icon: 'mdi-chart-gantt',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/gantt`,
            permissions: [permissions.Gantt.View],
          },
          {
            name: 'Schedule',
            icon: 'mdi-calendar-clock',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/schedule`,
            permissions: [permissions.Scheduler.View],
          },
          {
            name: 'Charts',
            icon: 'mdi-calendar-clock',
            path: `/${this.$route.params.id}/${this.$route.params.taskTypeId}/task-board-charts`,
            permissions: [permissions.TaskTracker.View],
          },
        ];
      },
      selectedTasks: {
        get() {
          return this.$store.getters['GANTT/GET_SELECTED_TASKS'];
        },
        set(val) {
          this.$store.commit('GANTT/SET_SELECTED_TASKS', val);
        },
      },
      lastIsolatedStatusId: {
        get() {
          return this.$store.getters['TASK/GET_LAST_ISOLATED_STATUS_ID'];
        },
        set(value) {
          this.$store.commit('TASK/SET_LAST_ISOLATED_STATUS_ID', value);
        },
      },
      activeFilterCount() {
        // Count the number of filters that have at least one selection
        if (!this.options) return 0;
        return Object.values(this.options).filter((arr) => Array.isArray(arr) && arr.length > 0).length;
      },
    },
    mounted() {
      log('[TaskBoard/mounted] entered, pendingRestore=', this.$store.state.VIEWERS_MODE?.pendingRestore);
      this.$store.dispatch('PROJECT/GET');
      this.$store.commit('SET_VIEWER_TYPE', '2d');
      // this.$store.dispatch('TASK_MANAGER/GET');
      //this.$store.dispatch('USER/GET');
      // this.$store.dispatch('TASKSTATUS/GET');

      // Issue 2 fix: if returning from a 360° expand, reconstruct the inline
      // viewer state (panel + tab + isolated task + scan).
      log('[TaskBoard/mounted] about to call _consumePendingRestoreIfAny');
      this._consumePendingRestoreIfAny();
    },
    beforeDestroy() {
      // Cancel the restoration safety-net timer if pending. Prevents the timer
      // callback from firing on a destroyed instance (would log spuriously and
      // touch detached `this` references).
      if (this._restoreFlagClearTimer) {
        clearTimeout(this._restoreFlagClearTimer);
        this._restoreFlagClearTimer = null;
      }
    },
    methods: {
      $has,
      openTask(isBult = false) {
        let today = new Date().toISOString();
        let task = {
          text: '',
          start_date: today,
          end_date: today,
          actualStartDate: null,
          actualEndDate: null,
        };
        let payLoad = {
          task,
          isNew: true,
          fromIndexPage: true,
          taskTypeId: this.$route.params.taskTypeId,
          isBulk: isBult,
        };
        this.$refs.editTask.open(payLoad);
      },
      openEvent() {
        this.$refs.recurringEvent.openDialog();
      },
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('TASK/GET_DATA', {
            typeId: this.$route.params.taskTypeId,
            sortBy: 'GanttOrder',
            // sortBy: this.$route.name === 'kanban' ? 'KanbanOrder' : 'GanttOrder',
          });

          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('TASK/GET_DATA', {
            typeId: this.$route.params.taskTypeId,
            sortBy: 'GanttOrder',
            // sortBy: this.$route.name === 'kanban' ? 'KanbanOrder' : 'GanttOrder',
          });
        }, 400);
      },
      getTaskType(id) {
        this.loadType = true;
        // Rebuild base-filter option URLs against the CURRENT board (the url segment
        // equals each filter's `prop`). Assigned SYNCHRONOUSLY here — before the async
        // task-type fetch — so a data load that completes first never preloads stale
        // (previous-board) base-filter options. These URLs can't live in data(): it
        // runs once for this persistent parent component and would freeze the first
        // board's taskTypeId.
        const typeId = this.$route.params.taskTypeId;
        const baseFilters = this.tempFilters.map((f) => ({
          ...f,
          url: `/api/Tasks/Filters/${typeId}/${f.prop}`,
          category: 'General',
        }));
        this.filters = baseFilters;
        this.$store
          .dispatch('TASK_MANAGER/GET_BY_ID', id)
          .then((res) => {
            // Ignore a stale resolution: if the user switched boards again while
            // this fetch was in flight, a newer getTaskType() is authoritative —
            // don't clobber its state with this (old) board's data.
            if (typeId !== this.$route.params.taskTypeId) return;
            this.currentTaskType = res;
            // Append the board's custom-field filters (base filters already set above).
            const withCustomFields = [...baseFilters];
            this.currentTaskType.sections.forEach((section) => {
              section.fields.forEach((field) => {
                let additionField = {
                  label: field.label,
                  placeholder: field.placeHolder,
                  // `fieldId` = stable raw field id (grouping + display-value lookup);
                  // `prop` = final data-request key (was rewritten on load before).
                  fieldId: field.id,
                  prop: `customFields[${field.id}]`,
                  url: `/api/Tasks/Filters/${typeId}/${field.id}`,
                  itemText: field.value,
                  // Option objects are keyed by `id` (see loadSingleFilterOptions);
                  // the field UUID lives in `fieldId`. itemValue must be 'id' so the
                  // autocomplete stores/reads the option id, not option[<uuid>].
                  itemValue: 'id',
                  category: section.name,
                };
                if (field.fieldType == TaskFieldType.Users) additionField['type'] = 'userList';
                withCustomFields.push(additionField);
              });
            });
            this.filters = withCustomFields;
          })
          .finally(() => {
            this.loadType = false;
          });
      },
      async showTasksOn3d(tasks) {
        if (!tasks || (Array.isArray(tasks) && tasks.length === 0)) {
          return;
        }

        if (!(tasks instanceof Array)) {
          tasks = [tasks];
        }

        tasks = tasks.filter((task) => task?.id);
        if (tasks.length === 0) return;

        // Resolve every persisted task through the shared batch endpoint.
        // This supplies monitoring scopes and anomaly ComponentRef contexts
        // without writing those parents into forgeTagsIds.
        try {
          await prefetchTasksIsolation(tasks, this.$store);
        } catch (err) {
          debugError('TaskBoard: task isolation prefetch failed', err);
        }

        const infoEntries = await Promise.all(
          tasks.map(async (task) => [
            task.id,
            await getTaskIsolationInfo(task, this.$store),
          ]),
        );
        this.taskIsolationInfoByTaskId = Object.fromEntries(
          infoEntries.filter(([, info]) => !!info),
        );

        tasks = tasks.filter(
          (task) => getTaskEffectiveTagIds(
            task,
            this.taskIsolationInfoByTaskId[task.id],
          ).length > 0,
        );
        if (tasks.length === 0) return;

        // Update Vuex isolation state.
        this.$store.commit('TASK/SET_ISOLATED_TASKS', tasks.map((t) => t.id));

        // Fetch FULL tag data (with children → dbIds, plus point/position used by
        // 2D/360 lookups). Summary tags from `task.forgeTags` lack children, so
        // isolation produces empty dbIds and nothing visibly applies. Mirrors the
        // GET_BASE_TAGS_BY_IDS dispatch the old TaskViewerSection ran inside
        // initializeViewerForTasks before setupViewerCallback.
        const tagsIds = [...new Set(tasks.flatMap((task) => getTaskEffectiveTagIds(
          task,
          this.taskIsolationInfoByTaskId[task.id],
        )))];
        try {
          const fullTags = await this.$store.dispatch('GET_BASE_TAGS_BY_IDS', tagsIds);
          this.isolatedTagsForViewer = Array.isArray(fullTags) ? fullTags : [];
        } catch (err) {
          debugError('TaskBoard: GET_BASE_TAGS_BY_IDS failed', err);
          // Fall back to summary tags so the viewer at least mounts; isolation
          // will be incomplete until the fetch succeeds.
          this.isolatedTagsForViewer = tasks.flatMap((t) => t.forgeTags ?? []);
        }

        if (this.isolatedTagsForViewer.length === 0) return;

        // Open the viewer panel and switch to 3D. The viewerTab watcher will
        // call loadViewerForCurrentTab → isolateTasksIn3dViewer.
        this.is3dOpened = true;
        this.viewerOpened = true;

        // Restoration guard: if we just back-navigated from a fullscreen 360°
        // expand, _consumePendingRestoreIfAny has already set viewerTab to the
        // user's prior tab ('360 View'). Don't clobber it — just re-run
        // isolation on the restored tab. Consumes the flag and cancels the
        // safety-net timer in one shot.
        if (this._isRestoringFromExpand) {
          this._isRestoringFromExpand = false;
          if (this._restoreFlagClearTimer) {
            clearTimeout(this._restoreFlagClearTimer);
            this._restoreFlagClearTimer = null;
          }
          log(`TaskBoard: showTasksOn3d skipping force-3D, restoration in progress (tab=${this.viewerTab})`);
          this.$nextTick(() => this.loadViewerForCurrentTab());
          return;
        }

        const plan = resolveTaskSpatialIntent(this.isolatedTagsForViewer, {
          currentFacilityId: this.$store.state.assetId,
          currentFacilityImageIds: (this.$store.state.projects || [])
            .flatMap((project) => project.images || [])
            .map((image) => image.id),
          intent: 'task-focus',
        });
        const targetTab = plan.kind === 'viewer' && plan.viewer === '360'
          ? '360 View'
          : '3D View';
        log(`TaskBoard: showTasksOn3d targetTab=${targetTab} (reason=${plan.reason}, tagsCount=${this.isolatedTagsForViewer.length})`);

        if (this.viewerTab === targetTab) {
          // Watcher won't fire if value is unchanged — invoke directly.
          this.$nextTick(() => this.loadViewerForCurrentTab());
        } else {
          this.viewerTab = targetTab;
        }
      },
      updateViewerStatusColors() {
        // TASK/MOVE updates the store silently, so its completion event must
        // trigger the repaint that reactive watchers cannot observe.
        const viewer = this.$store.state.viewer;
        if (!viewer) return;
        this.$refs.viewerTaskColoring?.onOptionChange?.();
      },
      addProject() {
        this.$refs.editProject.open(null, true);
      },
      onTabChange(tab) {
        if (tab.name === 'Gantt Chart') {
          this.$store.commit('GANTT/SET_RENDER_GANTT', true);
        } else if (tab.name === 'Schedule') {
          this.$store.commit('SCHEDULER/SET_RENDER_SCHEDULER', true);
        }
      },
      onCloseViewer() {
        // Migrated from old TaskViewerSection.onClosing — reset all Task viewer
        // state and tear down the coloring side effects. The shared component
        // emits 'closeViewersSection' (no boolean payload), so we drop the
        // legacy isClosed argument.
        this.is3dOpened = false;
        this.viewerOpened = false;
        this.isolatedTagsForViewer = [];
        this.taskIsolationInfoByTaskId = {};
        this.$store.commit('TASK/SET_ISOLATED_TASKS', []);
        this.$store.commit('SET_VIEWER_TYPE', '2d');
        this.$store.commit('GANTT/SET_RENDER_GANTT', true);
        this.$store.commit('SCHEDULER/SET_RENDER_SCHEDULER', true);
        this.$refs.viewerTaskColoring?.endMode?.();
      },
      showAllTasksIn3d() {
        this.lastIsolatedStatusId = null;
        if (this.entries.length) {
          // The unified entry point resolves direct and monitoring contexts.
          this.showTasksOn3d(this.entries);
        }
      },
      openFilters() {
        this.$refs.taskFilters.open(this.filters);
      },
      ganttActionsClick(action) {
        if (this.ganttToolbar.length > 0) {
          const index = this.ganttToolbar.indexOf(action);
          if (index !== -1) {
            this.ganttToolbar.splice(index, 1); // Remove the action if it exists
          } else {
            this.ganttToolbar.push(action); // Add the action if it doesn't exist
          }
        } else {
          this.ganttToolbar.push(action);
        }
      },
      zoomAction() {
        this.$refs.dhtmlx.zoomToFit();
      },
      updateCollectionSelected(value) {
        this.collectionSelected = value;
      },
      deleteSelectedGanttTasks() {
        this.$refs.dhtmlx.deleteSelectedTasks();
      },
      handleEditComplete() {
        // Filters will be loaded on-demand when TaskFilters opens
      },
      editSelectedGanttTasks() {
        let isBult = true;
        this.openTask(isBult);
      },

      /**
       * Phase 3 — Cross-viewer dispatcher (mirrors Registers/views/index.vue.loadViewerForCurrentTab).
       * Triggered by the viewerTab watcher when a tab transition fires while the
       * panel is open. Each branch invokes the shared component's public method
       * via $refs.viewersSection.
       */
      loadViewerForCurrentTab() {
        if (!this.viewerOpened) return;
        if (!this.isolatedTagsForViewer.length) return;
        switch (this.viewerTab) {
          case '3D View':
            this.isolateTasksIn3dViewer();
            break;
          case '2D View':
            this.isolateTasksIn2dViewer();
            break;
          case '360 View':
            this.isolateTasksIn360Viewer();
            break;
          default:
            // Unknown tab — silently skip; the shared component handles its own UI state.
        }
      },

      /**
       * Resolve a representative 3D point from the currently isolated tags.
       * Returns null when no tag exposes a usable point. Used to drive 2D-plan
       * level resolution and nearest-360-image lookup.
       */
      getPointFromCurrentTask() {
        for (const tag of this.isolatedTagsForViewer) {
          if (tag.point) return tag.point;
          if (tag.position) return tag.position;
          const child = tag.children?.find((c) => c.center);
          if (child?.center) return child.center;
        }
        return null;
      },

      /**
       * Phase 3 — Migrated 3D-isolation logic from TaskViewerSection.setupViewerCallback /
       * initializeViewerForTasks.
       *
       * Plan C: isolation, ghost context, exact-target colour, camera fit and pulse are ONE
       * decision and it lives in `ViewerTaskColoring` -> `useSpatialFocus`. What stays here are the
       * two retained low-level helpers the composable has no address for — the ForgeAvaInspect
       * crop volume and the ForgeScaffold box crop. Both own the CAMERA for their own tag kinds,
       * so they run AFTER the shared scene has rendered; that is why the delegation is awaited.
       */
      async isolateTasksIn3dViewer() {
        /* AVA-492 explicit-viewer */
        const Autodesk = window.Autodesk;
        const THREE = window.THREE;
        const tags = this.isolatedTagsForViewer;
        if (!tags.length) return;

        await this.$refs.viewersSection?.load3dViewer?.();

        const forgeService = this.$store.state.forgeService;
        const viewer = this.$store.state.viewer;
        if (!forgeService || !viewer) return;

        const callback = () => {
          setTimeout(async () => {
            log('%cTaskBoard: 3D isolation callback', 'color: #4caf50;');

            const cropExt = forgeService.getCropping3DExtension?.();
            cropExt?.clearCropBox?.();

            const scaffolds = tags
              .filter((t) => t.discriminator === 'ForgeScaffold')
              .map((i) => {
                const o = Object.assign(new ForgeScaffold(), i);
                o.parseContent();
                return o;
              });

            const avaInspects = tags
              .filter((t) => t.discriminator === 'ForgeAvaInspect')
              .map((i) => {
                const o = Object.assign(new ForgeAvaInspect(), i);
                o.parseContent();
                return o;
              });

            // Choose the encoding, then render the whole scene once through the one authority.
            this.$refs.viewerTaskColoring?.checkCriticalPath?.();
            await this.$refs.viewerTaskColoring?.applyColoringNow?.();

            if (avaInspects.length === 1 && avaInspects.length === tags.length) {
              const avaInspect = avaInspects[0];
              if (avaInspect.cropBox) {
                cropExt?.loadCropVolumeForTag?.(avaInspect);
                forgeService.zoomToPoint3dViewer?.(avaInspect.cropBox);
              }
            } else if (scaffolds.length > 0) {
              forgeService.getScaffoldBoxExtension?.().setIsolation(scaffolds.map((s) => s.id));
              let points = scaffolds.flatMap((s) => [s.getBox().min, s.getBox().max]) ?? [];
              const tagPoints = tags
                .flatMap((t) => t.point || t.position)
                .filter(Boolean)
                .map((p) => {
                  const v = new THREE.Vector3(p.x, p.y, p.z);
                  return forgeService.worldToView3d(v, v);
                });
              points = points.concat(tagPoints).filter(Boolean);
              const bbox = getBoxAroundPoints(points);
              forgeService.zoomToPoint3dViewer?.(bbox);
            }
          }, 100);
        };

        if (viewer?.model?.isLoadDone()) {
          callback();
        } else {
          viewer.addEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, callback, { once: true });
        }
      },

      /**
       * Phase 3 — 2D-plan transition (mirrors Registers/views/index.vue.isolateTagsIn2dViewer).
       * Resolves a level via forgeService.getLevelContainsPoint(point) and dispatches
       * the shared component's public load2dViewer method. Tag highlighting on the plan
       * is applied via Plan2DExtension after the zoom completes.
       */
      async isolateTasksIn2dViewer() {
        try {
          const tags = this.isolatedTagsForViewer;
          if (!tags.length) return;
          const point = this.getPointFromCurrentTask();
          if (!point) {
            this.$dialog?.notify?.warning?.('No position data available for 2D view');
            return;
          }
          const forgeService = this.$store.state.forgeService;
          const level = forgeService?.getLevelContainsPoint?.(point) || this.$store.state.levels?.[0];
          if (!level?.planUrn) {
            this.$dialog?.notify?.warning?.('No floor plan available for this location');
            return;
          }
          this.$store.state.selectedLevel = level;
          await this.$refs.viewersSection?.load2dViewer?.(level.planUrn);
          this.$store.dispatch('zoomToPointIn2D', {
            point3d: point,
            shouldZoom: true,
            callback: () => {
              forgeService?.getLabels2DExtension?.()?.createHighlightingTags?.(tags);
            },
          });
        } catch (err) {
          debugError('TaskBoard: 2D viewer load failed', err);
          this.$dialog?.notify?.error?.('Failed to show tasks in 2D view');
        }
      },

      /**
       * Phase 3 — 360°-panorama transition (mirrors Registers/views/index.vue.isolateTagsIn360Viewer).
       * Implements Decision #3: resolve the nearest panorama by tag location via
       * the existing forgeService.getClosestImageToPoint helper.
       */
      async isolateTasksIn360Viewer() {
        /* AVA-492 explicit-viewer */
        // Re-entrancy guard: a quick task switch re-enters this method before an
        // in-flight getById resolves. Each call bumps the sequence; an older call
        // bails once superseded so a stale scan never lands in the viewer.
        // (Fixes the user-reported "wrong scan on quick click" race.)
        const reqId = (this._iso360Seq = (this._iso360Seq || 0) + 1);
        const isStale = () => reqId !== this._iso360Seq;
        try {
          const projects = this.$store.state.projects || [];
          const plan = resolveTaskSpatialIntent(this.isolatedTagsForViewer, {
            currentFacilityId: this.$store.state.assetId,
            currentFacilityImageIds: projects
              .flatMap((project) => project.images || [])
              .map((image) => image.id),
            intent: 'task-focus',
          });
          const hasExactPlan = plan.kind === 'viewer'
            && plan.viewer === '360'
            && !!plan.image360Id;
          // Prefer a tag with explicit 360° placement (positionImage360Id) so we
          // honor the position the user pinned the tag at, not a geometrically
          // nearest scan. Fall back to the first tag if none is pinned.
          const tag = hasExactPlan
            ? this.isolatedTagsForViewer.find((candidate) => (
              !Array.isArray(plan.includedTagIds) || plan.includedTagIds.includes(candidate.id)
            ))
            : this.isolatedTagsForViewer.find((candidate) => candidate.positionImage360Id);
          const executionTag = tag || this.isolatedTagsForViewer[0];
          const image360Id = hasExactPlan ? plan.image360Id : executionTag?.positionImage360Id;
          const imageFacilityId = hasExactPlan ? plan.facilityId : this.$store.state.assetId;
          if (!executionTag) return;

          let imageToLoad = null;

          // Step 1: resolve the pinned scan by positionImage360Id.
          if (image360Id) {
            // Path A — warm projects cache (scan already loaded by a prior main-
            // viewer visit to this facility). Exact id match, never a wrong scan.
            imageToLoad = projects
              .flatMap((p) => p.images || [])
              .find((img) => img.id === image360Id);

            // Path B — cold cache: the taskboard route never loads state.projects,
            // so this is the common path here. Fetch the pinned scan directly and
            // wrap it in an Image360 (mirrors deriveViewerState.js). loadPannellumViewer
            // and the tag-zoom chain read plain x/y/z off the DTO, so a bare
            // Object.assign needs no THREE.Vector3 normalization.
            if (!imageToLoad) {
              try {
                const { data } = await images360Service.getById(image360Id, imageFacilityId);
                if (isStale()) return;
                if (data) imageToLoad = Image360.fromDTO(data);
              } catch (err) {
                debugError(
                  `TaskBoard: 360 API lookup failed for image360Id=${image360Id}`,
                  err,
                );
              }
            }
            log(
              imageToLoad
                ? `TaskBoard: 360 resolved exact scan ${image360Id}`
                : `TaskBoard: 360 exact scan ${image360Id} unresolved; trying closest-point`,
            );
          }

          // Step 2: geometric closest-image fallback — used when the tag has no
          // explicit placement OR the pinned scan is genuinely gone (deleted after
          // tagging). Reads the same projects cache.
          if (!imageToLoad) {
            const point = this.getPointFromCurrentTask();
            if (point) {
              const forgeService = this.$store.state.forgeService;
              if (forgeService?.getClosestImageToPoint) {
                // getPointFromCurrentTask() returns a WORLD-space point (also used
                // by 2D-plan level resolution). getClosestImageToPoint compares
                // against getCameraPositionInViewer() (VIEWER space), so convert —
                // mirrors the main-UI flow's element.getPointInView(). Fixes wrong
                // nearest-360 on facilities with a non-trivial globalOffset.
                const viewerPoint = forgeService.worldToView3d?.(point, point) ?? point;
                imageToLoad = forgeService.getClosestImageToPoint(viewerPoint);
                if (imageToLoad) {
                  log(`TaskBoard: 360 fell back to closest-image ${imageToLoad.id}`);
                }
              }
            }
          }

          if (isStale()) return;

          if (!imageToLoad) {
            this.$dialog?.notify?.warning?.('No 360 image found near this task');
            return;
          }
          await this.$nextTick();
          if (isStale()) return;
          await this.$refs.viewersSection?.loadPannellumViewer?.(imageToLoad, executionTag, 'pannellum-viewer');
        } catch (err) {
          debugError('TaskBoard: 360 viewer load failed', err);
          this.$dialog?.notify?.error?.('Failed to load 360 viewer');
        }
      },

      /**
       * Phase 3 — Tab-changed observability hook. The viewerTab watcher already
       * triggers the per-tab load; this handler is reserved for future cross-cutting
       * concerns (analytics, breadcrumb updates).
       */
      onTabChanged(newTab, prevTab) {
        log(`TaskBoard: viewer tab changed ${prevTab} -> ${newTab}`);
      },

      /**
       * Override ViewersSection's default fullscreen dispatch with Task-aware
       * routing: task-coloring mode for 3D (coloring overlay is useful), default
       * fullscreen mode for 2D and 360° (no useful overlay there). Back
       * navigation always returns to TaskBoard.
       */
      onExpandViewer({ activeTab, panoramaTransfer }) {
        log(
          `TaskBoard: expand requested from tab ${activeTab}, panoramaTransfer=` +
            (panoramaTransfer ? JSON.stringify(panoramaTransfer) : 'null'),
        );

        const VIEWER_TYPE_BY_TAB = {
          '3D View': '3d',
          '2D View': '2d',
          '360 View': '360',
        };

        // Issue 2 fix: capture inline state for back-restore. For 360° expand,
        // user expects panel + 360° tab + isolated task(s) restored on return.
        const taskRestore =
          activeTab === '360 View'
            ? {
                viewerTab: activeTab,
                forgeTagsIds: this.isolatedTagsForViewer.map((t) => t.id),
              }
            : null;

        this.$store.dispatch('VIEWERS_MODE/START_VIEWER_MODE', {
          mode: activeTab === '3D View' ? 'task-coloring' : 'dashboard-fullscreen',
          button: this.$route.name === 'kanban' ? 'Back to Kanban' : 'Back to Task Board Charts',
          viewer: VIEWER_TYPE_BY_TAB[activeTab],
          metadata: {
            taskTypeId: this.$route.params.taskTypeId,
            viewerMode: 'tasks',
            taskRestore,
          },
          panoramaTransfer,
        });
      },
      /**
       * Consume pendingRestore on TaskBoard mount after a back navigation from
       * a fullscreen viewer (expand button OR share-intent deep link).
       * Reconstructs the inline viewer state — panel open, correct tab (3D or
       * 360°), correct isolation — so the user returns to a fully-restored
       * TaskBoard view.
       *
       * Generalized from the original 360°-only version: now handles both
       * '3D View' and '360 View' restoration. The downstream
       * loadViewerForCurrentTab → isolateTasksIn{3d,360}Viewer chain handles
       * the actual viewer-side work.
       */
      async _consumePendingRestoreIfAny() {
        const restore = this.$store.state.VIEWERS_MODE?.pendingRestore;
        log('[TaskBoard/_consumePendingRestoreIfAny] entered, restore=', restore);

        const SUPPORTED_TABS = ['3D View', '360 View'];
        if (
          !restore ||
          !SUPPORTED_TABS.includes(restore.viewerTab) ||
          !restore.forgeTagsIds?.length
        ) {
          log('[TaskBoard/_consumePendingRestoreIfAny] gate failed — skipping');
          return;
        }

        log(
          `[TaskBoard/_consumePendingRestoreIfAny] consuming — tab=${restore.viewerTab}, tagIds=${restore.forgeTagsIds.length}`,
        );

        try {
          const fullTags = await this.$store.dispatch(
            'GET_BASE_TAGS_BY_IDS',
            restore.forgeTagsIds,
          );
          log('[TaskBoard/_consumePendingRestoreIfAny] tags fetched, count=',
            Array.isArray(fullTags) ? fullTags.length : 'N/A');
          this.isolatedTagsForViewer = Array.isArray(fullTags) ? fullTags : [];

          // Arm the guard so Kanban auto-isolation (which fires shortly after
          // mount via Kanban.vue:787-790 → showTasksOn3d) doesn't clobber our
          // restored viewerTab. Consumed by showTasksOn3d (yesterday's fix).
          this._isRestoringFromExpand = true;
          log('[TaskBoard/_consumePendingRestoreIfAny] armed _isRestoringFromExpand guard');

          // Safety net: if showTasksOn3d doesn't consume the flag within 3s
          // (e.g., user back-navigated to a non-Kanban subroute that doesn't
          // auto-isolate), auto-clear so a future legitimate showTasksOn3d
          // call isn't affected.
          if (this._restoreFlagClearTimer) clearTimeout(this._restoreFlagClearTimer);
          this._restoreFlagClearTimer = setTimeout(() => {
            if (this._isRestoringFromExpand) {
              this._isRestoringFromExpand = false;
              log('[TaskBoard/_consumePendingRestoreIfAny] safety: auto-cleared _isRestoringFromExpand guard after 3s');
            }
            this._restoreFlagClearTimer = null;
          }, 3000);

          this.viewerTab = restore.viewerTab;
          this.viewerOpened = true;
          log(`[TaskBoard/_consumePendingRestoreIfAny] state set: viewerTab=${this.viewerTab}, viewerOpened=true`);

          await this.$nextTick();
          log('[TaskBoard/_consumePendingRestoreIfAny] post-nextTick, viewerTab=', this.viewerTab,
            'viewerOpened=', this.viewerOpened, 'calling loadViewerForCurrentTab');
          this.loadViewerForCurrentTab();
        } catch (err) {
          debugError('[TaskBoard/_consumePendingRestoreIfAny] failed', err);
        } finally {
          this.$store.commit('VIEWERS_MODE/setPendingRestore', null);
          log('[TaskBoard/_consumePendingRestoreIfAny] done — pendingRestore cleared');
        }
      },
    },
    components: {
      // generalSelector,
      // UserAvatar,
      EditTask,
      ViewersSection,
      ViewerTaskColoring,
      IsolatedTagsDialog,
      EditProject,
      TaskFilters,
      RecurringEvent,
    },
    watch: {
      $route: {
        immediate: true,
        deep: true,
        handler(val, oldVal) {
          if (val.params.taskTypeId) {
            if (
              oldVal &&
              oldVal.params.taskTypeId &&
              oldVal.params.taskTypeId == val.params.taskTypeId
            ) {
              return;
            }

            // Cache check: if entries are already populated for THIS taskTypeId
            // (e.g., user round-tripped from a deep-link → fullscreen → back),
            // skip the heavy refetch. This avoids re-loading projects, custom
            // fields, and task data when nothing has changed. Cleared by
            // TASK/CLEAR which only fires on actual taskTypeId change.
            const lastLoadedTaskTypeId = this.$store.state.TASK?.lastLoadedTaskTypeId;
            const entriesItems = this.$store.state.TASK?.entries?.tasks?.items;
            const hasCachedEntries =
              lastLoadedTaskTypeId === val.params.taskTypeId &&
              Array.isArray(entriesItems) &&
              entriesItems.length > 0;
            if (hasCachedEntries) {
              log(`[TaskBoard/$route] skipping refetch — entries already loaded for taskTypeId=${val.params.taskTypeId}`);
              // Still ensure currentTaskType is populated (used by chrome).
              if (!this.currentTaskType || this.currentTaskType.id !== val.params.taskTypeId) {
                this.getTaskType(val.params.taskTypeId);
              }
              return;
            }

            this.getTaskType(val.params.taskTypeId);
            log(`[TaskBoard/$route] board switch → resetting filters for taskTypeId=${val.params.taskTypeId}`);
            this.$store.dispatch('TASK/CLEAR');
            this.getDataDebounced();
          }
        },
      },
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
      // Phase 3 of TaskBoard viewer migration — cross-viewer transitions are
      // driven by tab changes. Mirrors Registers/views/index.vue.viewerTab watcher.
      viewerTab() {
        if (this.viewerOpened) {
          this.loadViewerForCurrentTab();
        }
      },
    },
  };
</script>
<style lang="scss">
  .taskTypeTitle {
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: -0.01em;
    text-align: left;
  }
  // Task Board Tabs - Pill-shaped design matching reference UI
  .task-tabs {
    .v-tabs-bar {
      height: auto;
      background: transparent !important;
    }

    .v-tab {
      border-radius: 8px;
      height: 40px;
      min-width: auto;
      padding: 0 16px;
      margin-right: 8px;
      text-transform: none;
      font-weight: 500;
      font-size: 13px;
      letter-spacing: 0;

      // Smooth state transitions
      transition: all 0.2s ease;

      // Inactive state (light mode default)
      background-color: #f5f5f5;
      border: 1px solid #e0e0e0;
      color: #666 !important;

      .v-icon {
        color: #666 !important;
        margin-right: 6px;
      }

      &:hover:not(.v-tab--active):not(.activeTab) {
        background-color: #eeeeee;
        border-color: #d0d0d0;
      }

      // Disabled state
      &.v-tab--disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }

    // Active tab - outlined teal style matching reference design
    .v-tab--active,
    .v-tab.activeTab {
      font-weight: bold;
      border: 2px solid var(--v-primary-base) !important;
      color: var(--v-primary-base) !important;

      .v-icon {
        color: var(--v-primary-base) !important;
      }
    }
  }

  // Dark theme support for task tabs
  .theme--dark .task-tabs {
    .v-tab {
      background-color: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.12);
      color: rgba(255, 255, 255, 0.7) !important;

      .v-icon {
        color: rgba(255, 255, 255, 0.7) !important;
      }

      &:hover:not(.v-tab--active):not(.activeTab) {
        background-color: rgba(255, 255, 255, 0.12);
        border-color: rgba(255, 255, 255, 0.2);
      }
    }

    .v-tab--active,
    .v-tab.activeTab {
      font-weight: bold;
      border-color: var(--v-primary-base) !important;
      color: var(--v-primary-base) !important;

      .v-icon {
        color: var(--v-primary-base) !important;
      }
    }
  }
  .input-height-32 {
    .v-input__control {
      min-height: 32px !important;
    }
  }

  .task-section {
    min-width: 50%;
    flex: 1;
  }
  .customSearchBox {
    .v-input__control .v-input__slot {
      padding-right: 5px;
      .v-input__append-inner {
        margin-top: 5px !important;
        .v-input__icon--append {
          border-radius: 50%;
          background-color: var(--v-primary-base);
          width: 30px;
          height: 30px;
          i {
            color: var(--v-white-base) !important;
          }
        }
      }
    }
  }
  // .actions {
  //   .v-btn-toggle > .v-btn.v-btn {
  //     border-radius: 50%;
  //   }
  //   .v-btn-toggle > .v-btn.v-btn:first-child {
  //     border-top-left-radius: 50%;
  //     border-bottom-left-radius: 50%;
  //   }
  //   .v-btn-toggle > .v-btn.v-btn:last-child {
  //     border-top-right-radius: 50%;
  //     border-bottom-right-radius: 50%;
  //   }
  //   .v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  //     border-color: var(--v-primary-base) !important;
  //   }
  // }

  // Phase 3 of TaskBoard viewer migration
  .task-viewers-section-wrapper {
    position: relative;
    height: 100%;
    overflow: hidden;

    // Restore the absolute positioning the old TaskViewerSection.vue applied
    // via `#viewer-section-container #coloring-options`. After migration the
    // outer container changed, so this scoped rule reattaches the same offsets
    // for the slot-rendered ViewerTaskColoring overlay.
    #coloring-options {
      position: absolute;
      z-index: 2;
      top: 65px;
      left: 15px;
      padding: 8px;
      border-radius: 4px;
    }
  }

  // Phase 3 — Icon-button + corner-badge. Animation contract matches the
  // sibling .viewer-control-btn (expand/close) exactly: single 0.15s
  // color/transform transition, no compound motion, no scale-on-hover.
  // Badge is purely informational (no animation) — same as iOS / GitHub /
  // Gmail notification badges.
  .task-header-isolated-btn {
    position: relative;          // Anchors the absolute-positioned badge
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: 6px;
    border: none;
    border-radius: 6px;          // Matches .viewer-control-btn
    background: transparent;
    color: var(--v-primary-base);
    cursor: pointer;
    transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    .task-header-isolated-btn__icon {
      color: var(--v-primary-base) !important;
      transition: all 0.15s ease;
    }

    &:hover {
      background: rgba(var(--v-primary-base-rgb, 76, 175, 80), 0.15);
    }

    &:active:not(:disabled) {
      transform: scale(0.92);    // Matches .viewer-control-btn
    }

    &:focus-visible {
      outline: 2px solid var(--v-primary-base);
      outline-offset: 2px;
    }

    @media (prefers-reduced-motion: reduce) {
      transition: none;
      .task-header-isolated-btn__icon { transition: none; }
      &:active:not(:disabled) { transform: none; }
    }

    // Corner badge — static, no animation. White border creates a halo gap
    // that separates the badge from the button background even when the
    // button is hovered or pressed. Min-width grows with count (1 → 12 → 99+).
    .task-header-isolated-btn__badge {
      position: absolute;
      top: -3px;
      right: -3px;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      background: var(--v-primary-base);
      color: white;
      border-radius: 9px;
      border: 2px solid white;
      font-size: 10px;
      font-weight: 700;
      line-height: 14px;
      text-align: center;
      letter-spacing: 0.02em;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
      pointer-events: none;        // Click passes through to the button
    }
  }

  // Dark-theme support — badge border switches to a translucent dark ring so
  // the halo reads as a separator on dark chrome.
  .theme--dark {
    .task-header-isolated-btn__badge {
      border-color: rgba(0, 0, 0, 0.35);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    }
  }
</style>
